import { render } from "./tabSlot.vue?vue&type=template&id=2c94eb33&scoped=true"
import script from "./tabSlot.vue?vue&type=script&lang=js"
export * from "./tabSlot.vue?vue&type=script&lang=js"

import "./tabSlot.vue?vue&type=style&index=0&id=2c94eb33&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c94eb33"]])

export default __exports__